import { formatTimestampView } from '../utils/functions';
// columns machine_configuration
export const MachineConfigurationColumns = [
    /*{
        // aus den columns id entfernen, wenn sie nicht in der Tabelle erscheinen soll
        Header: 'Id', 
        accessor: 'id_machine_configuration',
        disableFilters: true, // Filtermoeglichkeit für id entfernt
        sticky: 'left' // Spalte links fixieren
    },*/
    {
        Header: 'Name Maschinenkonfiguration',
        accessor: 'machine_configuration_name',
        sticky: 'left' // Spalte links fixieren
    },
    {
        Header: 'Name Maschinentyp',
        accessor: 'machinetype_name', // nur zusaetzliche Anzeige zur Zuordnung Maschinentyp
    },
    {
        Header: 'Letzte Änderung',
        accessor: 'timestamp',
        /*Cell: ({ value }) => formatTimestampView(value),*/
        Cell: ({ value }) => formatTimestampView(value),
            sortType: (rowB, rowA) => {
            // Direktes Vergleichen der Timestamp-Werte für korrektes Sortieren
            const timestampA = rowA.values.timestamp;
            const timestampB = rowB.values.timestamp;

            return new Date(timestampB) - new Date(timestampA);
        }
    },
    {
        Header: 'Produkt',
        accessor: 'product',
    },
    {
        Header: 'Fournisseur',
        accessor: 'yarn_feeder',
    },
    {
        Header: 'Spezielle Fournisseur',
        accessor: 'additional_special_feeder',
    },
    {
        Header: 'Fadenspannung',
        accessor: row => row.thread_tension ? `${row.thread_tension} ${row.unit_thread_tension_name}` : '',
        Cell: ({ value }) => {
            // Wenn `value` leer ist oder `thread_tension` keinen Inhalt hat, gebe einen leeren String zurueck
            return value.trim() === '' ? '' : value;
        },
    },
    {
        Header: 'Schlittengeschwindigkeit',
        accessor: (row) => {
            // Kombiniere Schlittengeschwindigkeit und Einheit
            const carriage_speed = row.carriage_speed;
            const unit = row.unit_carriage_speed_name;
            if (!carriage_speed && !unit) return null; // Fallback, falls Werte fehlen            
            return `${carriage_speed} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);           
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const carriage_speed = parseFloat(value);
                if (isNaN(carriage_speed)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "m/s":
                        return carriage_speed * 3.6 ; // 1 m/s =  3.6 km/h
                    case "km/h":
                        return carriage_speed; // bereits in km/h
                    default:
                        return carriage_speed; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Schlittengeschwindigkeit']);
            const mmsB = convertToMM(rowB.values['Schlittengeschwindigkeit']);           
            return mmsA - mmsB;
        },
        
        /*accessor: row => `${row.carriage_speed} ${row.unit_carriage_speed_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Kuliertiefe',
        accessor: (row) => {
            // Kombiniere Kuliertiefe und Einheit
            const cullet_depth = row.cullet_depth;
            const unit = row.unit_cullet_depth_name;
            if (!cullet_depth && !unit) return null; // Fallback, falls Werte fehlen            
            return `${cullet_depth} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);           
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return numericValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const cullet_depth = parseInt(value);
                if (isNaN(cullet_depth)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "mm":
                        return cullet_depth * 1000 ; // 1 mm = 1000 µm
                    case "µm":
                        return cullet_depth; // bereits in µm
                    default:
                        return cullet_depth; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Kuliertiefe']);
            const mmsB = convertToMM(rowB.values['Kuliertiefe']);           
            return mmsA - mmsB;
        },
        
        /*accessor: row => `${row.cullet_depth} ${row.unit_cullet_depth_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return numericValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Abzugseinstellung',
        accessor: (row) => {
            // Kombiniere Abzugseinstellung und Einheit
            const hauloff_adjustment = row.hauloff_adjustment;
            const unit = row.unit_hauloff_adjustment_name;
            if (!hauloff_adjustment && !unit) return null; // Fallback, falls Werte fehlen            
            return `${hauloff_adjustment} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);          
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const hauloff_adjustment = parseFloat(value);
                if (isNaN(hauloff_adjustment)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "m":
                        return hauloff_adjustment * 1000 ; // 1 m = 1000 mm
                    case "mm":
                        return hauloff_adjustment; // bereits in mm
                    default:
                        return hauloff_adjustment; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Abzugseinstellung']);
            const mmsB = convertToMM(rowB.values['Abzugseinstellung']);           
            return mmsA - mmsB;
        },

        /*accessor: row => `${row.hauloff_adjustment} ${row.unit_hauloff_adjustment_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const floatValue = parseFloat(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return floatValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Einstreifer für Schussfaden',
        accessor: 'inserter_for_weft_thread', // checkbox true, false
        Cell: ({ value }) => (value ? 'ja' : 'nein') // Konvertiere boolean zu 'ja' oder 'nein'
    },
    {
        Header: 'Schiene für Zuführung von Kettfäden',
        accessor: 'builtin_rail_warp_threads', // checkbox true, false
        Cell: ({ value }) => (value ? 'ja' : 'nein') // Konvertiere boolean zu 'ja' oder 'nein'
    },
    {
        Header: 'Sinker',
        accessor: (row) => {
            // Kombiniere sinker_adjustment und Einheit
            const sinker_adjustment = row.sinker_adjustment;
            const unit = row.unit_sinker_adjustment_name;
            if (!sinker_adjustment && !unit) return null; // Fallback, falls Werte fehlen            
            return `${sinker_adjustment} ${unit}`;
          },
        
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);           
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return numericValue < 0 ? '' : value;
        },
        sortType: (rowA, rowB) => {
            const convertToMM = (valueWithUnit) => {
                if (!valueWithUnit) return 0; // Fallback für fehlende Werte
                const [value, unit] = valueWithUnit.split(" ");
                const sinker_adjustment = parseInt(value);
                if (isNaN(sinker_adjustment)) return 0; // Fallback für ungültige Werte
                switch (unit) {
                    case "m":
                        return sinker_adjustment * 1000 ; // 1 m = 1000 mm
                    case "mm":
                        return sinker_adjustment; // bereits in mm
                    default:
                        return sinker_adjustment; // Fallback
                }
            };
            const mmsA = convertToMM(rowA.values['Sinker']);
            const mmsB = convertToMM(rowB.values['Sinker']);           
            return mmsA - mmsB;
        },


        /*accessor: row => `${row.sinker_adjustment} ${row.unit_sinker_adjustment_name}`,
        Cell: ({ value }) => {
            // Extrahiere den numerischen Teil aus der Zeichenkette
            const numericValue = parseInt(value);
            
            // Wenn der numerische Teil 0 ist, gebe einen leeren String zurück
            return numericValue < 0 ? '' : value;
        },*/
    },
    {
        Header: 'Sonstige',
        accessor: 'machine_configuration_others',
    },
    {
        Header: (
            <div style={{ transform: 'rotate(-90deg)', width: '45px', height: '40px', textAlign: 'left' }}>
                Rezept Anzahl
            </div>
        ),
        accessor: 'count_in_recipe',
        disableFilters: true, // Filtermoeglichkeit für id entfernt
    },
]
